import { playAudio, parsingAI } from '@/utils/audioPlay';
import { ICompletionProp, IlistItem } from '@/utils/ctype';
import i18n from '@/locales/init'; 
import MyInput from '../../../components/MyInput';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';

export default function Completion(props: ICompletionProp & {index: number;isJudge?: boolean; className?: string;}) {
  const { data, saveAnswerHandle, type, groupId, answerMap, isAI, isListen, keyIndex, index: itemIndex, answerAllText, setFocusIndexHandle, feedbackMap} = props;
  const { title, number, id } = data;
  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    const {target} = event;
    const {value} = target as HTMLInputElement;
    saveAnswerHandle(number, {group_id: groupId, type, id: data.id, answer: [value]});
  };


  const createAIType = (answer: string, listItem: IlistItem) => {
    if (!isAI) {
      return;
    }
    if (feedbackMap && listItem.id) {
      return feedbackMap[listItem.id];
    }
  };
  
  const value = answerMap[`${groupId}_${type}_${id}`] && answerMap[`${groupId}_${type}_${id}`][0];

  return <div className={style.completion} data-key={`question.question.${keyIndex}.list.${itemIndex}.title`}>
    <HtmlParser htmlString={title} ></HtmlParser>
    <MyInput 
      placeholder={String(number)} 
      id={`question${number}`} 
      onInput={handleInput} 
      value={value} 
      type={createAIType(value, data)} 
      playAudio={() => {playAudio(data);}} 
      parsingAI={() => {parsingAI(data);}} 
      isListen={isListen}
      answerKey={`answerAllText.${number - 1}`}
      answer={answerAllText[number - 1]}
      dataKey={`question.question.${keyIndex}.list.${itemIndex}.display_answerHtml`} 
      displayAnswer={data?.display_answerHtml} 
      numberKey={`$question.question.${keyIndex}.list.${itemIndex}.number`} 
      numberHtml={data.numberHtml}
      onFocus={()=>{setFocusIndexHandle&&setFocusIndexHandle(number);}}></MyInput>
  </div>;
}

